"use client";

import { c as _c } from "react/compiler-runtime";
import { AppProgressProvider as ProgressProvider } from "@bprogress/next";
import { MotionConfig } from "motion/react";
import { ThemeProvider } from "next-themes";
import { PostHogIdentityProvider } from "@/components/analytics/posthog-identity";
import { TRPCProvider } from "@/trpc/client";
import { TooltipProvider } from "@domainstack/ui/tooltip";
export function Providers(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showSpinner: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [0.22, 1, 0.36, 1];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.18,
      ease: t2 as const
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <TRPCProvider><PostHogIdentityProvider><ThemeProvider attribute="class" defaultTheme="system" storageKey="theme" enableSystem={true} disableTransitionOnChange={true}><TooltipProvider><ProgressProvider options={t1} shallowRouting={true} disableStyle={true}><MotionConfig reducedMotion="user" transition={t3}>{children}</MotionConfig></ProgressProvider></TooltipProvider></ThemeProvider></PostHogIdentityProvider></TRPCProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}